"use client";

import axios from "axios";

const axiosInstance = axios.create({
	baseURL: process.env.NEXT_PUBLIC_API_BASE_URL,
});

axiosInstance.interceptors.request.use(
	(config) => {
		config.headers["Access-Control-Allow-Origin"] = "*";
		config.headers["Access-Control-Allow-Methods"] =
			"GET, POST, PUT, DELETE, OPTIONS";
		config.headers["Access-Control-Allow-Headers"] =
			"Content-Type, Authorization";
		const token =
			sessionStorage.getItem("token") || localStorage.getItem("token");
		if (token) {
			config.headers.Authorization = `Bearer ${token}`;
		}
		return config;
	},
	(error) => {
		return Promise.reject(error);
	},
);

/**
 * Endpoints where a 401 means "that credential was wrong", not "your session
 * died". Without this, one mistyped digit in the 2FA field wipes the token and
 * hard-redirects to /login, throwing the error toast away with the page — the
 * user gets logged out mid-enrolment with no explanation.
 */
const CREDENTIAL_CHECK_PATHS = [
	"/two-factor/verify",
	"/two-factor/disable",
	"/two-factor/reenrol/setup",
	"/two-factor/reenrol/verify",
	"/account/change-password",
	"/auth/verify-totp",
];

const isCredentialCheck = (url?: string) =>
	!!url && CREDENTIAL_CHECK_PATHS.some((path) => url.includes(path));

axiosInstance.interceptors.response.use(
	(response) => response,
	(error) => {
		// 401 = the session token is missing / expired / invalid. Drop the
		// session and send the user to login instead of letting every page
		// surface a generic "โหลดข้อมูลไม่สำเร็จ" error.
		if (
			error.response &&
			error.response.status === 401 &&
			!isCredentialCheck(error.config?.url) &&
			typeof window !== "undefined"
		) {
			localStorage.removeItem("token");
			localStorage.removeItem("role");
			sessionStorage.removeItem("token");
			sessionStorage.removeItem("role");

			// Guard against redirect loops (e.g. the login request itself 401s).
			if (window.location.pathname !== "/login") {
				window.location.replace("/login");
			}
		}
		return Promise.reject(error);
	},
);

export default axiosInstance;
